import { render } from "./Luggages.vue?vue&type=template&id=48021c1b&scoped=true"
import script from "./Luggages.vue?vue&type=script&lang=js"
export * from "./Luggages.vue?vue&type=script&lang=js"

import "./Luggages.vue?vue&type=style&index=0&id=48021c1b&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48021c1b"]])

export default __exports__